import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["aria-expanded", "tabindex"]
const _hoisted_2 = { class: "accordion" }
const _hoisted_3 = { class: "accordion__text" }
const _hoisted_4 = {
  key: 0,
  class: "left-icon"
}
const _hoisted_5 = {
  key: 0,
  class: "sub-text"
}

import IconChevroneUpMedium from '@/design-system/assets/icons/IconChevroneUpMedium.vue'
interface EMITS {
  (e: 'onClicked')
}

export default /*@__PURE__*/_defineComponent({
  __name: 'AccordionInfoDisplay',
  props: {
    heading: { default: '' },
    isExpanded: { type: Boolean, default: false },
    leftIcon: { type: Boolean, default: false },
    subText: { default: '' },
    tabIndex: { default: 0 }
  },
  emits: ["onClicked"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit


function onClicked(event?: Event, preventDefault?: boolean) {
  if (event && preventDefault) event.preventDefault() // Prevent space bar scrolling
  emits('onClicked')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "aria-expanded": _ctx.isExpanded,
    class: "accordion-container",
    tabindex: _ctx.tabIndex,
    role: "button",
    onClick: onClicked,
    onKeydown: [
      _withKeys(onClicked, ["enter"]),
      _cache[0] || (_cache[0] = _withKeys((event) => onClicked(event, true), ["space"]))
    ]
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.leftIcon)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _renderSlot(_ctx.$slots, "leftIcon")
            ]))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(_ctx.heading), 1)
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["accordion__arrow-button", { 'accordion__arrow-button__rotated': !_ctx.isExpanded }])
      }, [
        _createVNode(IconChevroneUpMedium, { class: "accordion__arrow-button__icon" })
      ], 2)
    ]),
    (_ctx.subText.length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.subText), 1))
      : _createCommentVNode("", true)
  ], 40, _hoisted_1))
}
}

})